// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorData from "./ErrorData.bs.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Caml_js_exceptions from "@rescript/std/lib/es6/caml_js_exceptions.js";

function item(json) {
  return {
          themeUid: Json_decode.field("theme_uid", Json_decode.string, json),
          themeImage: Json_decode.field("theme_image", Json_decode.string, json),
          themekeyColour: Json_decode.field("theme_key_colour", Json_decode.string, json),
          themeTextColour: Json_decode.field("theme_text_colour", Json_decode.string, json),
          value: Json_decode.field("value", Json_decode.string, json),
          originalBalance: Json_decode.field("original_balance", Json_decode.string, json),
          valueCurrency: Json_decode.field("value_currency", Json_decode.string, json),
          originalBalanceCurrency: Json_decode.field("original_balance_currency", Json_decode.string, json),
          balance: Json_decode.field("balance", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          balanceCurrency: Json_decode.field("balance_currency", Json_decode.string, json),
          expiry: Json_decode.field("expiry", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          isExpired: Json_decode.field("is_expired", Json_decode.bool, json),
          balanceUpdatedAt: Json_decode.field("balance_updated_at", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          notes: Json_decode.field("uid", Json_decode.string, json),
          uid: Json_decode.field("uid", Json_decode.string, json),
          productType: Json_decode.field("product_type", Json_decode.string, json),
          cardLabel: Json_decode.field("card_label", Json_decode.string, json),
          cardPin: Json_decode.field("card_pin", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          cardId: Json_decode.field("card_id", Json_decode.string, json),
          number: Json_decode.field("number", Json_decode.string, json),
          barcodeNumber: Json_decode.field("barcode_number", Json_decode.string, json),
          barcodeLabel: Json_decode.field("barcode_label", Json_decode.string, json),
          instoreNumber: Json_decode.field("instore_number", Json_decode.string, json),
          onlineNumber: Json_decode.field("online_number", Json_decode.string, json),
          pin: Json_decode.field("pin", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          pinFieldName: Json_decode.field("pin_field_name", Json_decode.string, json),
          cardBarcodeFormat: Json_decode.field("card_barcode_format", Json_decode.string, json),
          cardLogo: Json_decode.field("card_logo", Json_decode.string, json),
          merchantTerms: Json_decode.field("merchant_terms", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          status: Json_decode.field("status", Json_decode.string, json),
          subtype: Json_decode.field("subtype", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          updatedAt: Json_decode.field("updated_at", Json_decode.string, json),
          activatedAt: Json_decode.field("activated_at", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          createdAt: Json_decode.field("created_at", Json_decode.string, json),
          receivedAt: Json_decode.field("received_at", Json_decode.string, json),
          gift: null,
          isSwapCard: Json_decode.field("is_swap_card", Json_decode.bool, json),
          isSchemeCard: Json_decode.field("is_scheme_card", Json_decode.bool, json),
          swapCard: Json_decode.field("swap_card", Json_decode.bool, json),
          donation: Json_decode.field("donation", Json_decode.bool, json),
          supportsRegift: Json_decode.field("supports_regift", Json_decode.bool, json),
          supportsBalanceCheck: Json_decode.field("supports_balance_check", Json_decode.bool, json),
          supportsAppleWalletExport: Json_decode.field("supports_apple_wallet_export", Json_decode.bool, json),
          supportsGoogleWalletExport: Json_decode.field("supports_google_wallet_export", Json_decode.bool, json),
          receiptText: Json_decode.field("receipt_text", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          receiptLogoTop: Json_decode.field("receipt_logo_top", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          redemptionUrl: Json_decode.field("redemption_url", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          balanceCheckUrl: Json_decode.field("balance_check_url", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          howToUse: Json_decode.field("how_to_use", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          skuDisplayName: Json_decode.field("sku_display_name", Json_decode.string, json),
          skuUid: Json_decode.field("sku_uid", Json_decode.string, json),
          pdfUrl: Json_decode.field("pdf_url", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          defaultProductCode: Json_decode.field("default_product_code", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          defaultProductThemeCode: Json_decode.field("default_product_theme_code", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          defaultSkuUid: Json_decode.field("default_sku_uid", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json)
        };
}

function safeDecodeCardData(json) {
  var result;
  try {
    result = item(json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Json_decode.DecodeError) {
      return ErrorData.Decode.safeDecodeError(json);
    }
    throw exn;
  }
  return {
          TAG: /* Ok */0,
          _0: result
        };
}

var Decode = {
  item: item,
  safeDecodeCardData: safeDecodeCardData
};

export {
  Decode ,
}
/* No side effect */
